'use client'

import React from 'react'
import dynamic from 'next/dynamic'

import { useTranslations, useLocale } from 'next-intl'

import { useHeaderAuth } from '@/src/hooks/header/useHeaderAuth'
import { useHeaderUI } from '@/src/hooks/header/useHeaderUI'
import { useHeaderRTL } from '@/src/hooks/header/useHeaderRTL'

import { MobileHeader } from './MobileHeader'

const SignInModalWrapper = dynamic(
    () => import(/* webpackChunkName: "signin-modal" */ '../flyin/SignInModal/SignInModalWrapper'),
    { ssr: false }
)

interface MobileHeaderContainerProps {
    hideSignIn?: boolean
    domainCountry?: string
}

const MobileHeaderContainer: React.FC<MobileHeaderContainerProps> = ({ hideSignIn = false, domainCountry }) => {
    const locale = useLocale()
    const t = useTranslations('header')

    const { user, handleSignOut, isMounted } = useHeaderAuth()
    const uiHook = useHeaderUI()
    const rtlHook = useHeaderRTL()

    const displayUser = isMounted ? user : { signedIn: false }

    return (
        <>
            <MobileHeader
                user={displayUser}
                menuAnchor={uiHook.menuStates.user ? uiHook.menuAnchors.user : null}
                onMenuOpen={(event) => uiHook.onMenuOpen('user', event)}
                onMenuClose={() => uiHook.onMenuClose('user')}
                onModalOpen={() => uiHook.onModalOpen('signIn')}
                onSignOut={handleSignOut}
                t={t}
                disableUserMenu={hideSignIn}
                locale={locale}
                isRTL={rtlHook.isRTL}
                direction={rtlHook.direction}
                domainCountry={domainCountry}
            />
            <SignInModalWrapper
                open={uiHook.modals.signIn}
                onClose={() => uiHook.onModalClose('signIn')}
                onMenuClose={() => uiHook.onMenuClose('user')}
            />
        </>
    )
}

export { MobileHeaderContainer as MobileHeader }
export default MobileHeaderContainer
